import SpriteSymbol from "../../../node_modules/svg-sprite-loader/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-layoutdesc",
  "use": "icon-layoutdesc-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-layoutdesc\"><defs><style type=\"text/css\"></style></defs><path d=\"M113.777778 0h796.444444a56.888889 56.888889 0 0 1 56.888889 56.888889v512a455.111111 455.111111 0 1 1-910.222222 0V56.888889a56.888889 56.888889 0 0 1 56.888889-56.888889z m387.072 640l150.471111 79.075556-28.728889-167.537778 121.742222-118.670222-168.220444-24.462223L500.849778 256 425.642667 408.462222l-168.277334 24.462222 121.742223 118.613334-28.728889 167.594666 150.471111-79.132444z\" p-id=\"81508\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/layoutdesc.svg
// module id = 9ehA
// module chunks = 7